export default __webpack_public_path__ + "static/media/admins.eb6814fa.txt";